define('app/sf/median/sf-median-filter',["factory!sf-aggregate-filter"], function (Aggregate) {
	return new Aggregate(function median(values) {
		if (values.length === 1) {
			return angular.extend(Object.create(Aggregate.Item), {
				effective: values[0].effective,
				actual: [values[0].effective],
				key: [values[0].key]
			});
		}
		values.sort(function (a, b) { return a - b; });
		var iMiddle = Math.floor(values.length / 2);
		if (values.length % 2) {
			var middle = values[iMiddle];
			return angular.extend(Object.create(Aggregate.Item), {
				effective: middle.effective,
				actual: [middle.actual],
				key: [iMiddle]
			});
		}
		else {
			var iFirst = iMiddle - 1;
			var iSecond = iMiddle;
			var first = values[iFirst];
			var second = values[iSecond];
			return angular.extend(Object.create(Aggregate.Item), {
				effective: (first + second) / 2.0,
				actual: [first, second],
				key: [iFirst, iSecond]
			});
		}
	});
});
